import assetPath from '/app/brewery-packages/xds/xing-logo/src/assets/xing-apple-touch-icon.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')